import Grid from "./grid.js";
import ribbonColourer from "./colour-ribbons.js";
import { child } from "./dom.js";
import storage from "./common/data.js";

const preview = document.getElementById("colour-scheme-preview");
const grid = new Grid(4, 3);
grid.toggleWall(4, 3, false);
grid.toggleWall(3, 2, false);
grid.toggleWall(3, 4, false);
grid.toggleWall(2, 3, true);
grid.toggleWall(5, 4, true);
const colourRibbons = ribbonColourer();
const markers = [
	{ x: 3, y: 0, colour: 0 }, { x: 7, y: 5, colour: 0 },
	{ x: 2, y: 4, colour: 1 }, { x: 4, y: 3, colour: 1 }
];
preview.appendChild(grid.el);
grid.update();
colourRibbons(grid.ribbons, markers);
for (const b of markers)
	b.el = child(grid.cells[b.y][b.x].td, `div.bead.p${b.colour + 1}`);

const select = document.getElementById("colour-scheme");
select.value = storage.colourScheme;
document.body.classList.add(select.value);
select.addEventListener('change', e => {
	for (const { value } of select.querySelectorAll("option"))
		document.body.classList.remove(value);
	document.body.classList.add(select.value);
	storage.colourScheme = select.value;
});
